

















































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateAccountDepositOverdraftSettingsRequest from '@/models/Accounts/DepositAccounts/Settings/UpdateAccountDepositOverdraftSettingsRequest';
import CurrencyUtils from '@/lib/currencyUtils';

@Component({ name: 'AccountDepositOverdraftSettingsEditDialog' })
export default class extends SaascadaVueDialog {

    request: UpdateAccountDepositOverdraftSettingsRequest = new UpdateAccountDepositOverdraftSettingsRequest(null, null, null);
    hardLimitWasEmpty: boolean = false;
    hardLimitOverride: boolean = false;
    reviewDateAsString: string = '';
    todaysDateAsString: string = new Date().toISOString().split('T')[0];

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateAccountDepositOverdraftSettingsRequest(DepositAccountSettingsModule.settings.depositOverdraftSettings, new Date(), DepositAccountSettingsModule.productIssue.generalSettings.defaultWalletCurrency);
            // Check if hard limit is zero to set the empty flag
            if (this.request.hardLimit.amount === "0.00") {
                this.hardLimitWasEmpty = true;
            }
            // If hard limit is not empty, check if both limits are the same or not to set the override switch
            if (!this.hardLimitWasEmpty && (this.request.softLimit.amount !== this.request.hardLimit.amount)) {
                this.hardLimitOverride = true;
            }
            else {
                this.hardLimitOverride = false;
            }
            // Initialise the date
            this.reviewDateAsString = this.request.reviewDateUtc ? new Date(this.request.reviewDateUtc).toISOString().split('T')[0] : '';
        }
    }

    @Watch('request.softLimit.amount')
    async onRequestSoftLimitChanged(val: string) {
        // If the hard limit was empty or the hard limit override is off then soft/hard limit should match
        if (this.hardLimitWasEmpty || !this.hardLimitOverride) {
            this.request.hardLimit.amount = val;
        }
    }

    @Watch('hardLimitOverride')
    async onHardLimitOverrideChanged(val: boolean) {
        // When the override switch is off, reset the hard limit to match the soft limit
        if (!val) {
            this.request.hardLimit.amount = this.request.softLimit.amount;
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings.depositOverdraftSettings;
    }

    get productIssue() {
        return DepositAccountSettingsModule.productIssue;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            this.request.hardLimit.amount = CurrencyUtils.convertDecimalStringToAmountString(this.request.hardLimit.amount);
            this.request.softLimit.amount = CurrencyUtils.convertDecimalStringToAmountString(this.request.softLimit.amount);

            // The date picker only saves date so we need to convert to date-time format
            this.request.reviewDateUtc = this.reviewDateAsString ? new Date(this.reviewDateAsString) : undefined;

            //This needs setting to undefined currently as it is getting stored in the JSON.
            //Plan was to send this and backend ignores it until we get concurrency checking in
            this.request.updatedAt = undefined;

            await DepositAccountSettingsModule.editDepositOverdraftSettings(this.request);
            //await DepositAccountModule.getDepositAccount(DepositAccountModule.depositAccount.id);
        }
    }

}
